import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBathMan1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBathMan1"><Path d="M12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1Z" fill="currentColor"/><Path d="M8.5 8C7.11929 8 6 9.11929 6 10.5V15.5C6 16.3284 6.67157 17 7.5 17H8V21.5C8 22.3284 8.67157 23 9.5 23H14.5C15.3284 23 16 22.3284 16 21.5V17H16.5C17.3284 17 18 16.3284 18 15.5V10.5C18 9.11929 16.8807 8 15.5 8H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBathMan1;
